/**
 * Carousel Accommodation
 * https://swiperjs.com/
 */

// import Swiper from 'swiper';

import Swiper from "Vendor/swiper.js";
import $ from "jquery";

let carouselAccommodationDetailImage = undefined;

export default function carousel() {
  // When Carousel exists
  if (carousel) {
    let $obj = $(".carousel-accommodation-detail-image");

    $obj.each(function (index, element) {
      let $this = $(this);

      if (!$this.hasClass("swiper-container-horizontal")) {
        carouselAccommodationDetailImage = new Swiper(this, {
          slidesPerView: 1,
          spaceBetween: 16,
          nested: true,
          pagination: {
            el: ".swiper-pagination",
            dynamicBullets: false,
          },
          lazy: {
            loadPrevNext: true,
            loadPrevNextAmount: 1,
          },
          navigation: {
            nextEl: $this.find(".swiper-button-next"),
            prevEl: $this.find(".swiper-button-prev"),
          },
        });
      }
    });

    window.addEventListener("DOMContentLoaded", imageRatio);
    window.addEventListener("resize", imageRatio);

    function imageRatio() {
      let imageSel = document.querySelector(
        ".carousel-accommodation-detail-image .swiper-slide"
      );
      if (imageSel) {
        let imageSelWidth = imageSel.offsetWidth;
        let imageSelHeight = (imageSelWidth / 3) * 2.125;
        let imageSelAll = document.querySelectorAll(
          ".carousel-accommodation-detail-image .swiper-slide"
        );
        for (let i = 0; i < imageSelAll.length; i++) {
          imageSelAll[i].style.height = imageSelHeight + "px";
        }
      }
    }

    window.addEventListener("DOMContentLoaded", setBookmarkLabels);
    function setBookmarkLabels() {
      var rawData = localStorage.getItem("bookmarks");
      var bookmarks = rawData ? JSON.parse(rawData) : { unit_ids: [] };

      var bookmarkButtons = document.querySelectorAll(".btn-bookmark"); // Select all bookmark buttons

      bookmarkButtons.forEach(function (bookmarkButton) {
        var unitId = parseInt(bookmarkButton.getAttribute("data-unitid")); // Parse the unitId to an integer
        if (bookmarks.unit_ids.includes(unitId)) {
          bookmarkButton.classList.add("active"); // Add "active" class to the bookmark button if unit_id is in bookmarks
        } else {
          bookmarkButton.classList.remove("active"); // Remove "active" class if unit_id is not in bookmarks
        }
      });

      var navbarBookmarked = document.getElementById("navbar-bookmarked");
      if (navbarBookmarked) {
        if (Array.isArray(bookmarks.unit_ids)) {
          navbarBookmarked.textContent = bookmarks.unit_ids.length;
          if (bookmarks.unit_ids.length > 0) {
            navbarBookmarked.classList.add("show");
          }
        } else {
          navbarBookmarked.classList.remove("show");
        }
      }
    }
  }
}
